import { render } from "./EstruturaAcademica.vue?vue&type=template&id=c5b29c86"
import script from "./EstruturaAcademica.vue?vue&type=script&lang=js"
export * from "./EstruturaAcademica.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__